import React, { useContext } from "react";
import { GlobalDataContext } from "../context/context";
import TransparentHeader from "../components/global/TransparentHeader";
import BaseLayout from "../components/global/BaseLayout";
import ValuesOne from "../components/values/Values_2";
import BlockFour from "../components/block/BlockFour";
import BlockOne from "../components/block/BlockThree";

function About() {
  const { rpdata } = useContext(GlobalDataContext);
  return (
    <BaseLayout PageName="About">
      <div className="md:max-w-full w-full">
        <TransparentHeader
          headertitle="About"
          Subheader="About"
          bgimg={`${rpdata?.stock?.[6]}`}
        />
        <BlockOne
          title={'a little about us'}
          text={rpdata?.dbAbout?.[0].text}
          image={rpdata?.stock?.[1]}
          listsAbout={true}
        />
        <ValuesOne image={rpdata?.stock?.[4]} />

        <BlockFour
          title={rpdata?.dbSlogan?.[2]?.slogan}
          text={rpdata?.dbAbout?.[1]?.text}
          image1={rpdata?.stock?.[7]}
          image2={rpdata?.stock?.[3]}
          image3={rpdata?.stock?.[5]}
        />
      </div>
    </BaseLayout>
  );
}

export default About;
